import { BehaviorSubject } from 'rxjs';

import { Service } from '../../../symphony';
import { IProjectData, ILanguage } from '../../../api/public/code-api';

@Service()
export class SlDataService {
	public codeBitsList$ = new BehaviorSubject<IProjectData[]>(null);

	public supportedLanguages$ = new BehaviorSubject<ILanguage[]>(null);

	public codeBitsListCount$ = new BehaviorSubject<number>(null);

	public isCodeBitsListLoading$ = new BehaviorSubject<boolean>(false);

	public hotTodayProjects$ = new BehaviorSubject<IProjectData[]>(null);
}
